/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Input, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ISettingsTable } from '../interfaces/table.interface';
import { ExportUtil, ISettingToExport } from '../utils/export';

@Component({
  template: ''
})
export class AmiTableTemplate {
  @ViewChild('dt') table: Table;
  @Input() settings: ISettingsTable;
  @Input() data: unknown;
  listingData = true;
  cols: any[];
  _selectedColumns: any[];

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.settings.columns.filter((col) =>
      val.includes(col)
    );
  }

  getDataToExport(): any[] {
    if (this.table.hasFilter()) {
      return this.table.filteredValue;
    }
    return this.table.value;
  }

  getSettingToExport(): ISettingToExport {
    return {
      title: this.settings.title,
      columns: this._selectedColumns,
      data: this.getDataToExport()
    };
  }
  exportPdf() {
    ExportUtil.exportPdf(this.getSettingToExport());
  }

  exportExcel() {
    ExportUtil.exportExcel(this.getSettingToExport());
  }
}
